import builder from '../builder';
import BuildingNature from '../../streamline-icons/bold/building-nature.svg';

export default builder('IconBuildingNatureBold', BuildingNature);
